import { Box } from "@mui/material";
import { filterPage } from "components/common/Filters/FiltersHelper";
import GlobalFilterDescription from "components/common/Filters/GlobalFilterDescription";
import GlobalFilters from "components/common/Filters/GlobalFilters";
import Scroller from "components/common/Scroller/InfiniteScroller";
import Item from "components/common/plans/item";
import { useTranslate } from "hooks/useTranslate";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { PAGE_SIZE, brandDeadlinesType, initiativePlansType } from "utils/CommonConstants";
import { formFilterRequestPayload, getLoggedInUserDetails } from "utils/CommonFunctions";
import { fetchDeadlineAndInitiativesPlans } from "../IndividualProperty.slice";
import NoPropertyPlansBanner from "../NoPropertyPlansBanner";

interface Props {
  type: string;
}

function IndividualTypeList(props: Props) {
  const translate = useTranslate();
  const params = useParams();
  const dispatch = useAppDispatch();
  const { type = "" } = props;

  const [page, setPage] = useState(1);

  const inncode = useAppSelector((state) => state.app.innCode);
  const {
    deadlineAndInitiativesPlans: { list, totalRecords },
    showIndividualPropertyLoader
  } = useAppSelector((state) => state.individualProperty);

  const pageName =
    type === translate("dashboard.IndividualProperty.Initiative")
      ? filterPage.individualPropertyInitiativesDisplay
      : filterPage.individualPropertyBrandDeadlineDisplay;

  const globalFiltersforPage = useAppSelector((state) => state.globalFilters[pageName]);
  const filterRequestPayload = globalFiltersforPage?.modifiedFilter || globalFiltersforPage?.defaultFilter || [];
  const formattedFilterRequestPayload = formFilterRequestPayload(filterRequestPayload);
  const searchText = globalFiltersforPage.searchText;

  useEffect(() => {
    const payload = {
      filter: { innCode: params?.inncode || inncode, ...formattedFilterRequestPayload },
      pagination: { page, size: PAGE_SIZE },
      searchText,
      planType:
        type === translate("dashboard.IndividualProperty.Initiative") ? [initiativePlansType] : [brandDeadlinesType],
      fetchAllImplementedPlans: true
    };

    dispatch(fetchDeadlineAndInitiativesPlans(payload));
  }, [page, inncode, searchText, filterRequestPayload]);

  useEffect(() => {
    setPage(1);
  }, [inncode, searchText, filterRequestPayload]);

  const fetchMore = () => setPage((pageNo) => pageNo + 1);

  return (
    <>
      <Box marginTop={"16px"}>
        <GlobalFilters
          isPreDefinedNav
          isSearchBarVisible
          innCode={params?.inncode || inncode}
          page={pageName}
          searchedText={searchText}
        />
      </Box>
      <GlobalFilterDescription page={pageName} bgColor={tokens.Background.General.Primary} />
      {list?.length ? (
        <Scroller
          dataLength={list.length}
          loadMore={fetchMore}
          totalList={totalRecords}
          label={translate("dashboard.PlanLabel")}
        >
          {list.map((item: any) => {
            return (
              <Item
                key={item.id}
                item={item}
                showBookmarked={false}
                redirectFromDashboard={!(getLoggedInUserDetails().roleCategory === "Leadership")}
                fetchAllImplementedPlans={getLoggedInUserDetails().roleCategory === "Leadership"}
              />
            );
          })}
        </Scroller>
      ) : (
        !showIndividualPropertyLoader && <NoPropertyPlansBanner />
      )}
    </>
  );
}

export default IndividualTypeList;
